import axios from "axios";

const baseURL = process.env.NODE_ENV==="production"?"https://paulinesafrica.org/api/v1/":"https://paulinesafrica.org/api/v1/"

const axiosInstance = axios.create({
  baseURL,  
  // You can also set other default configurations here if needed
});

export default axiosInstance;
